import api from "./api";

async function createCardRefund(cardPaymentId, amount) {
  try {
    const response = await api.post(
      `api/cardrefunds`,
      {
        cardPaymentId,
        amount
      },
    );

    return response.data;
  } catch (error) {
    return [];
  }
}

export { createCardRefund };